export default "__VITE_ASSET__iunojWcA__"